import { Col, Row, CardBody } from "reactstrap";

import Breadcrumbs from "@components/ui-components/breadcrumbs";
import DataTableView from "@components/views/datatable-view";
import DateRangePicker from "@components/fields/date-picker/range-picker";
import Flex from "@components/ui-components/flex";
import useDateHandler from "@hooks/use-date-handler";
import usePageChange from "@hooks/use-page-change";
import { useTeamPerformance } from "./use-team-performance";
import { useTranslation } from "react-i18next";
import Card from "@src/@core/components/ui-components/card";
import { LAST_7_DAYS_DATE } from "@src/utility/constants";
import { LoaderOverlay } from "@src/@core/components/spinner";

const TeamPerformanceReport = () => {
    const {
        data: { users = [], pagination = {}, aott = 0, aodt = 0, act = 0, anc = 0 },
        loading,
        columns,
        setQueryParams,
        getTeamPerformance
    } = useTeamPerformance();
    const { control, handleDateChange } = useDateHandler({
        onSubmit       : getTeamPerformance,
        defaultValues  : LAST_7_DAYS_DATE,
        defaultHandling: true
    });
    const { t } = useTranslation();

    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });

    return (
        <>
            <Breadcrumbs
                items={[{ title: "Team Performance Report", active: true }]}
                rightChildren={
                    <Flex align="center">
                        <DateRangePicker
                            control={control}
                            customOnChange={handleDateChange}
                            maxDate={new Date()}
                            id="date"
                            name="date"/>
                    </Flex>
                }/>

            <h5 className="mt-2 fw-bold h4">{t("Team Performance Overview")}</h5>
            <Row className="match-height">
                <Col md="3" sm="6">
                    <Card containerClass="bg-light-primary mb-5 h-100">
                        <CardBody>
                            <h5 className="text-primary">{t("On-time Tasks")}</h5>
                            <span className="font-large-2 fw-bolder text-primary">
                                {aott || 0}
                            </span>
                        </CardBody>
                    </Card>
                </Col>
                <Col md="3" sm="6">
                    <Card containerClass="bg-light-warning mb-5 h-100">
                        <CardBody>
                            <h5 className="text-warning">{t("Overdue Tasks")}</h5>
                            <span className="font-large-2 fw-bolder text-warning">
                                {aodt || 0}
                            </span>
                        </CardBody>
                    </Card>
                </Col>
                <Col md="3" sm="6">
                    <Card containerClass="bg-light-success mb-5 h-100">
                        <CardBody>
                            <h5 className="text-success">{t("Completed Tasks")}</h5>
                            <span className="font-large-2 fw-bolder text-success">
                                {act || 0}
                            </span>
                        </CardBody>
                    </Card>
                </Col>
                <Col md="3" sm="6">
                    <Card containerClass="bg-light-info mb-5 h-100">
                        <CardBody>
                            <h5 className="text-info text-start">{t("Total Notes")}</h5>
                            <span className="font-large-2 fw-bolder text-info text-start">
                                {anc || 0}
                            </span>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <LoaderOverlay
                active={loading}
                children={
                    <DataTableView
                        moduleName={"Per User Breakdown"}
                        loading={loading}
                        tableProps={{
                            data: users || [],
                            columns,
                            handlePageChange,
                            handlePerRowsChange,
                            pagination
                        }}/>
                }/>
        </>

    );
};

export default TeamPerformanceReport;
